/* eslint-disable import/no-default-export */
import React from 'react';

import classNames from 'classnames';

import { TestId } from '@trello/webdriverio-tests';
import Icon, { IconColor, IconName } from 'app/common/components/controls/icon';
import forwardRefComponent from 'app/common/lib/util/forward-ref-component';
import styles from './close-button.less';

interface CloseButtonProps {
  className?: string;
  color?: IconColor;
  quiet?: boolean;
  large?: boolean;
  onClick: React.EventHandler<React.MouseEvent<HTMLElement>>;
  small?: boolean;
  style?: React.CSSProperties;
  testId?: TestId;
}

export default forwardRefComponent<HTMLButtonElement, CloseButtonProps>(
  'CloseButton',
  (
    {
      className,
      color,
      large = false,
      onClick,
      small = false,
      quiet = false,
      style,
      testId,
    },
    ref,
  ) => (
    <button
      className={classNames(styles.closeButton, className)}
      onClick={onClick}
      style={style}
      ref={ref}
      data-test-id={testId}
    >
      <Icon
        color={color}
        large={large}
        name={IconName.Close}
        small={small}
        quiet={quiet}
      />
    </button>
  ),
);
